module.exports = __webpack_public_path__ + "img/3.abb8783f.jpg";